import React from 'react';
import { useTheme } from 'styled-components';

import accountGraphicLight from 'static/account-graphic.light-mode.svg';
import accountGraphicDark from 'static/account-graphic.dark-mode.svg';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function AccountGraphic() {
  const theme = useTheme();

  const asset = theme.name === 'darkTheme' ? accountGraphicDark : accountGraphicLight;

  return <img src={asset} alt="account icon" width={82} height={87} />;
}

export default AccountGraphic;
